    <template>
    <span>
        <v-avatar
        v-if="initials"
        :size="height ? height : '48px'" 
        :color="backgroundColor"
        :style="{'font-size':fontSize ? fontSize : 'inherit'}">        
        <strong v-if="!documentId && initials" class="white--text pa-1">{{initials}}</strong>            
        </v-avatar>     
             <v-img 
                v-if="!documentId && !initials"
                style="cursor:pointer" 
                @click="showImageDialog(userImage)" 
                cover :src="userImage" 
                :height="!size ? '24px' : size=='small' ? '24px' : size=='medium' ? '48px' : size=='large' ? '64px' : '128px'" 
                :width="!size ? '24px' :  size=='small' ? '24px' : size=='medium' ? '48px' : size=='large' ? '64px' : '128px'" 
    
            />
            <v-img 
                v-if="documentId"
                style="cursor:pointer" 
                @click="showImageDialog(userImage)" 
                contain :src="userImage" 
                :height="!size ? '24px' : size=='small' ? '24px' : size=='medium' ? '48px' : size=='large' ? '64px' : '128px'" 
                :width="!size ? '24px' :  size=='small' ? '24px' : size=='medium' ? '48px' : size=='large' ? '64px' : '128px'" 
    
            />
        <!--span class="indigo--text caption">
                Change Picture
        </span-->
        <v-dialog v-if="imageDialog" width="350px" v-model="imageDialog" >
             <v-card>
                 <v-card-title>
                     <v-spacer/>
                     <v-icon @click="closeImageDialog" medium >fas fa-times</v-icon>
                </v-card-title>
                <v-container
                    fluid
                    grid-list-md
                >
                    <v-img :src="userImage"/>     
                    <CameraView v-if="cameraMode" keyType="PP" 
                        :keyId="keyId" v-on:closeCamera="closeCamera" 
                     />   
                </v-container>
                <v-card-actions class="text-xs-center" v-if="!readOnly">
                    <v-container justify-center class="pa-0 ma-0">
                     <v-chip small @click="showCamera"  class="indigo white--text">
                        <v-icon class="amber--text" small >fas fa-camera</v-icon> &nbsp; 
                        <span >Take Picture</span>
                    </v-chip> 
                    <FileConverterButton  :key_id="keyId" dataType="PP" v-on:uploadCompleted="uploaded"/>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>
<script>
import DocumentModel from '@/api/service/DocumentService.js'
import CameraView from '@/components/CameraView.vue'
import FileConverterButton from '@/components/FileConverterButton'
import randomColor from 'randomcolor';

export default {
    props:["documentId","keyId","readOnly","height","width","size","initials","color", "fontSize"],
    components:{
        FileConverterButton,CameraView
    },
    data() {
        return {
         
            cameraMode:false,
            imageDialog:false,
             userImage: require('@/assets/preview.svg') 
        }
    },
    created:function() {
         
        this.getDocuments()
    },
    mounted:function() {

    },
    computed:{
        backgroundColor() {
            if(this.initials) { 
                return this.color ? this.color : randomColor.randomColor({
   luminosity: 'dark',seed:this.initials})

            } else {
                return 'transparent';
            }
        }
    },
    watch: {
        documentId() {
            this.getDocuments()
        }
    },
    methods:{
        getDocuments() {
         if(this.documentId) {
            DocumentModel.getImage({"id":this.documentId})
                .then(response =>{
                    this.userImage = response
                }).catch(error =>{
                    console.log(error)
                })
         } else {
            this.userImage=require('@/assets/preview.svg') 
         }
        },
        showCamera() {
            this.cameraMode=true
        },
        closeCamera($image){
            this.cameraMode=false
            this.$emit('imageChanged',$image)
        },
        showImageDialog($image) {
            this.imageDialog=true
        },
        getStyle() {
            return 'color:'+(this.color ? this.color : '##27b5f2')
        },
        closeImageDialog() {
            this.imageDialog=false
        },
        uploaded($image) {
            this.$emit('imageChanged',$image)
        },
    }
}
</script>
<style>
.img-circle {
    border-radius: 50%;
    
}
.my-icon {
    vertical-align: top;
}
</style>